import {EnderecoSuper} from './endereco-super';
import {Endereco} from './endereco';
import {Construtor} from './construtor';

export class EnderecoUsuario extends EnderecoSuper implements Construtor<EnderecoUsuario> {

  public idEnderecoUsuario: number;
  public idUsuario: number;
  public alterado: boolean;

  constructor(object?: any) {
    super();
    this.endereco = new Endereco();

    if (object !== undefined) {
      if (object instanceof EnderecoUsuario) {
        this.copyObject(object);
      } else if (object instanceof Endereco) {
        this.Endereco = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  get obterIdEnderecoUsuario(): number {
    return this.idEnderecoUsuario;
  }

  set IdEnderecoUsuario(idEnderecoUsuario: any) {
    this.idEnderecoUsuario = idEnderecoUsuario;
  }

  get obterIdUsuario(): number {
    return this.idUsuario;
  }

  set IdUsuario(idUsuario: any) {
    this.idUsuario = idUsuario;
  }

  copyObject(enderecoUsuario: EnderecoUsuario): void {
    this.idEnderecoUsuario = enderecoUsuario.obterIdEnderecoUsuario;
    this.idUsuario = enderecoUsuario.obterIdUsuario;
    this.Endereco = enderecoUsuario.endereco;
  }

  parseFromJson(enderecoUsuario: any): void {
    this.IdEnderecoUsuario = enderecoUsuario.idEnderecoUsuario;
    this.IdUsuario = enderecoUsuario.idUsuario;
    this.Endereco = enderecoUsuario.endereco;
  }

  modeloCompleto(): boolean {
    return this.endereco.modeloCompleto();
  }

  getNewInstance(object?: any): EnderecoUsuario {
    return new EnderecoUsuario(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/endereco-usuario.ts